import { DateTime } from 'luxon';
import { getDateTime } from './getDateTime';

const fromIsoDate = (args: { isoDate: string; timezone: string }) => {
  const { timezone, isoDate } = args;
  // Does not use getDateTime since it returns yesterday's date
  return DateTime.fromISO(isoDate)
    .setZone(timezone)
    .toJSDate();
};

const now = (args: { timezone: string }) => {
  const { timezone } = args;

  return getDateTime.now({ timezone }).toJSDate();
};

export const getJsDate = {
  fromIsoDate,
  now
};
